export { useMorphemeInfoPanelSentencesExamplesSection } from "#morpheme-info-panel-sentences-examples-section";
export { useMorphemeInfoPanelSentencesWordExamplesSection } from "#morpheme-info-panel-sentences-word-examples-section";
